"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Badge_1 = require("./components/Badge");
const react_1 = __importDefault(require("react"));
const ListComponent_1 = require("./components/ListComponent");
const DropdownComponent_1 = require("./components/DropdownComponent");
const cell_1 = require("webapp-genric/dist/super-table/model/cell");
const Indicator_1 = require("./components/Indicator");
const TextWithCaption_1 = require("./components/TextWithCaption");
const TextLinks_1 = require("./components/TextLinks");
const ActionComponent_1 = require("./components/ActionComponent");
const ButtonComponent_1 = require("./components/ButtonComponent");
const util_1 = require("../../util");
const ObjectToStringComponent_1 = require("./components/ObjectToStringComponent");
exports.Cell = ({ type, value, onAction, row, table, colIndex, rowIndex, col, }) => {
    const _type = util_1.convertSerializedIntoJS(type, row, col);
    const { styleClasses } = col;
    const classes = util_1.convertSerializedIntoJS(styleClasses || "", row, col);
    const getCell = () => {
        switch (_type) {
            case "obj":
                return react_1.default.createElement(ObjectToStringComponent_1.ObjectToString, { value: value.child, col: col });
            case cell_1.CellType.BADGE:
                return (react_1.default.createElement(Badge_1.BadgeComponent, { rowIndex: rowIndex, colIndex: colIndex, col: col, row: row, className: classes, type: value.variant, child: value.child }));
            case cell_1.CellType.BUTTON:
                return (react_1.default.createElement(ButtonComponent_1.ButtonComponent, { className: classes, action: col.action, row: row, col: col, onAction: onAction, colIndex: colIndex, rowIndex: rowIndex, value: value }));
            case cell_1.CellType.ACTION:
                return (react_1.default.createElement(ActionComponent_1.ActionComponent, { className: classes, row: row, onAction: onAction, col: col, rowIndex: rowIndex, colIndex: colIndex, actions: table === null || table === void 0 ? void 0 : table.commonRowActions, child: value.child }));
            case cell_1.CellType.LIST:
                return (react_1.default.createElement(ListComponent_1.ListComponent, { col: col, className: classes, data: value.child || [] }));
            case cell_1.CellType.DROPDOWN:
                return react_1.default.createElement(DropdownComponent_1.DropdownComponent, { col: col, data: value.child || [] });
            case cell_1.CellType.INDICATOR:
                return react_1.default.createElement(Indicator_1.Indicator, { value: value.child });
            case cell_1.CellType.TEXT_LINK:
                return (react_1.default.createElement(TextLinks_1.TextLinks, { col: col, className: classes, colIndex: colIndex, rowIndex: rowIndex, value: value.child }));
            case cell_1.CellType.TEXT:
            case cell_1.CellType.TEXT_WITH_CAPTION:
                return (react_1.default.createElement(TextWithCaption_1.TextWithCaption, { className: classes, row: row, col: col, colIndex: colIndex, rowIndex: rowIndex, onAction: onAction, value: value.child }));
            default:
                return react_1.default.createElement("div", { className: "shimmer" });
        }
    };
    return getCell();
};
//# sourceMappingURL=index.js.map